import shuffle from 'lodash/shuffle';
import { makeArrayEvenLength } from 'core/utils/array';
import { BUY_ONLINE_PICKUP_INSTORE_GET_SUCCESS, BUY_ONLINE_PICKUP_INSTORE_GET_FAILURE } from '../actions/types';
import buyOnlinePickupInstoreConfig from '../configs';

const initialState = {
  config: buyOnlinePickupInstoreConfig,
  merchants: [],
  isLoading: false,
  isLoaded: false,
};

const formatMerchants = merchants => (
  merchants.length > 1 ? shuffle(makeArrayEvenLength(merchants)) : merchants
);

const buyOnlinePickupInstore = (state = initialState, action) => {
  switch (action.type) {
    case BUY_ONLINE_PICKUP_INSTORE_GET_SUCCESS: {
      const placements = action.payload.response;
      const merchants = placements.map(placement => placement.merchant);
      return {
        ...state,
        merchants: formatMerchants(merchants),
        isLoading: false,
        isLoaded: true,
      };
    }
    case BUY_ONLINE_PICKUP_INSTORE_GET_FAILURE: {
      return {
        ...state,
        merchants: [],
        isLoading: false,
        isLoaded: true,
      }; // we'd have to decide what to do with error state
    }
    default: {
      const { options = {} } = action;

      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === BUY_ONLINE_PICKUP_INSTORE_GET_SUCCESS) {
        return { ...state, isLoading: true, isLoaded: false };
      }

      return state;
    }
  }
};

export default buyOnlinePickupInstore;
